import { useEffect, useRef, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import Popup from "reactjs-popup";
import About from "./About";
import "./App.scss";
import Art from "./Art";
import FAQ from "./FAQ";
import Home from "./Home";
import email from "./images/email-icon-png-email-icon-2048-633966439.png";
import instagram from "./images/instagram-png-instagram-icon-1600-2611987004.png";
import logo from "./images/logo-with-text-pink.png";
import menu from "./images/menu-icon.png";
import { Org } from "./Org";
import OurValues from "./OurValues";
import TenantOrg from "./TenantOrg";
import Unions from "./Unions";
import ESLTU from "./unions/ESLTU";
import TheDouglas from "./unions/TheDouglas";

function App() {
  const [atBottom, setAtBottom]: [boolean, any] = useState(true);
  const join = useRef(null);
  const location = useLocation();
  const emailPopup = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries, observer) => {
      //setAtBottom(entry.isIntersecting)
      setAtBottom(window.scrollY > 0);
    });
    if (join && join.current) {
      observer.observe(join.current!);
    }
  });

  useEffect(() => {
    console.log(location);
  }, [location]);

  return (
    <div className="App">
      <Popup ref={emailPopup} position="right center">
        <div className="modal email-modal">
          <p>
            Email us at <a href="mailto:ranpdx@proton.me">ranpdx@proton.me</a>
          </p>
        </div>
      </Popup>

      <header className="navbar">
        <div className="row">
          <Link to="/" className="logo">
            <img src={logo}></img>
          </Link>
          <button className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            <img src={menu} />
          </button>
        </div>
        <div className="contact-options">
          <a
            href="https://instagram.com/rentersactionnetworkpdx"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="instagram"></img>
          </a>
          <button
            className="email"
            onClick={() => (emailPopup.current as any).open()}
          >
            <img src={email} alt="email"></img>
          </button>
        </div>
      </header>
      {menuOpen && (
        <div className="navbar-options">
          {location.pathname !== "/about" && (
            <a href="/about" className="option">
              About Us
            </a>
          )}
          {/* {location.pathname !== "/unions" && (
              <a href="/unions" className="option">
                Our Unions
              </a>
            )} */}
          {
            <a href="https://tenantstribune.noblogs.org" className="option">
              The Tenants Tribune
            </a>
          }
          {location.pathname !== "/tenant-organizing" && (
            <a href="/tenant-organizing" className="option">
              Tenant Organizing
            </a>
          )}
          {location.pathname !== "/art" && (
            <a href="/propaganda" className="option">
              Propaganda
            </a>
          )}
          {location.pathname !== "/faq" && (
            <a href="/faq" className="option">
              FAQs
            </a>
          )}
        </div>
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="about" element={<About />} />
        <Route path="tenant-organizing" element={<TenantOrg />} />
        <Route path="propaganda" element={<Art />} />
        <Route path="our-values" element={<OurValues />} />
        <Route path="org-my-building" element={<Org />} />
        <Route path="unions" element={<Unions />} />
        <Route path="unions/esltu" element={<ESLTU />} />
        <Route path="unions/the-douglas" element={<TheDouglas />} />
      </Routes>
    </div>
  );
}

export default App;
